import axios from 'axios';
/**
 * 获取商品列表
 *
 * @param {*} params
 * @param {string} key      授权Token
 * @param {number} isasc    升降序 0-降序 1-升序
 * @param {string} type     自定义日期筛选关键字 today this_week custom 等
 * @param {string} sday	    开始时间，格式：YYYY-MM-DD
 * @param {string} eday	    结束时间，格式：YYYY-MM-DD
 * @param {number} days     最近多少天  0-历史到现在  -1-自定义，根据 sday eday 表示起止时间 其他-最近数最近多少天
 * @param {number} page	    页码
 * @param {number} page_num 条数/页
 */
export function requestPaymentList(params) {
  return axios.post('/payment/view_all', params);
}
/**
 * 搜索流水
 *
 * @param {*} params
 * @param {string} key     授权 Token
 */
export function requestPaymentSearch(params) {
  return axios.post('/payment/search_by_id', params);
}

export function requestGetExcel(params) {
  return axios.get('/report/export_payment', { responseType: 'blob', params: params });
}
